import '@hapana/shared/utils/type-defs.util'

import { EQUIPMENT_ASSIGNMENT_STATUSES } from '_constants/equipments'

/** @type {Styles} */
export const styles = {
  dialogContent: { padding: 0 },
  content: { paddingY: 2.5, paddingX: 4 },
  groupContainer: { paddingTop: 2 },
  groupHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  list: { display: 'flex', flexDirection: 'column' },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingY: 3,
    '&:first-child': { paddingTop: 2 },
    '&:not(:first-child)': { borderTop: '1px solid', borderColor: 'gray.12' },
  },
  left: { display: 'flex', alignItems: 'center', gap: 2 },
  iconWrapper: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconWrapperSuccess: { backgroundColor: 'success.lightest' },
  iconWrapperError: { backgroundColor: 'error.lightest' },
  iconWrapperOngoing: { backgroundColor: 'warning.lightest' },
  details: { display: 'flex', flexDirection: 'column', gap: 0.5 },
  titleRow: { display: 'flex', alignItems: 'center', gap: 1 },
  times: { color: 'gray.64' },
  right: { color: 'gray.64' },
  divider: { marginX: -3, marginBottom: 2 },
  dateFilters: { display: 'flex', gap: 2, mt: 2 },
  emptyMessage: { mt: 2 },
  loadingContainer: { marginTop: 2 },
}

export const handleStylesWithProps = (status) => ({
  statusIcon: {
    color:
      status === EQUIPMENT_ASSIGNMENT_STATUSES.DONE
        ? 'success.dark'
        : status === EQUIPMENT_ASSIGNMENT_STATUSES.CANCELLED
          ? 'error.main'
          : 'warning.dark',
  },
})
